"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _inputField = require("../shared-components/inputs/input-field");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var RadioGroup = exports.RadioGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioGroup, _React$Component);
  function RadioGroup(props) {
    var _this;
    _classCallCheck(this, RadioGroup);
    _this = _callSuper(this, RadioGroup, [props]);
    _this.state = {
      errorText: ''
    };
    _this.changeHandler = _this.changeHandler.bind(_assertThisInitialized(_this));
    _this.renderUserInput = _this.renderUserInput.bind(_assertThisInitialized(_this));
    _this.returnRadioGroupValue = _this.returnRadioGroupValue.bind(_assertThisInitialized(_this));
    _this.isValid = _this.isValid.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(RadioGroup, [{
    key: "changeHandler",
    value: function changeHandler() {
      this.setState({
        errorText: ''
      });
      var selectedEle = $("input[name=".concat(this.props.groupName, "]:checked"))[0];
      this.props.inputData.map(function (input) {
        if (input.collectUserInput) {
          var userInputEle = document.getElementById("input-div-".concat(input.ID));
          if (selectedEle.id === input.ID) {
            $(userInputEle).removeClass('hide');
          } else {
            $(userInputEle).addClass('hide');
          }
        }
      });
    }
  }, {
    key: "returnRadioGroupValue",
    value: function returnRadioGroupValue() {
      var value;
      var selectedEle = $("input[name=".concat(this.props.groupName, "]:checked"))[0];
      var userInput = selectedEle ? $("#input-".concat(selectedEle.id))[0] : '';
      if (userInput) {
        value = userInput.value;
      } else {
        value = selectedEle ? selectedEle.value : '';
      }
      return _lodash.default.trim(value);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      var value = this.returnRadioGroupValue();
      var isValid = true;
      var errorText;
      if (this.props.isRequired) {
        if (!value) {
          errorText = 'Please select or fill in your reason';
          isValid = false;
        } else if (5 >= value.length) {
          errorText = 'Minimum is 5 characters';
          isValid = false;
        } else if (1000 < value.length) {
          errorText = 'Maximum is 1,000 characters';
          isValid = false;
        }
      }
      this.setState({
        errorText: errorText
      });
      return isValid;
    }
  }, {
    key: "renderUserInput",
    value: function renderUserInput(input) {
      if (input.collectUserInput) {
        return /*#__PURE__*/_react.default.createElement("div", {
          id: "input-div-".concat(input.ID),
          className: "hide"
        }, /*#__PURE__*/_react.default.createElement(_inputField.InputField, {
          elementID: "input-".concat(input.ID),
          inputFieldName: "default_textarea",
          placeholder: input.userEnterPlaceholder,
          colSize: " "
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement("div", null, this.props.inputData.map(function (input, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-12",
          key: i
        }, /*#__PURE__*/_react.default.createElement("input", {
          id: input.ID,
          name: _this2.props.groupName,
          onChange: _this2.changeHandler,
          type: "radio",
          value: input.value
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: input.ID
        }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", null))), /*#__PURE__*/_react.default.createElement("span", {
          htmlFor: input.ID
        }, input.displayText), _this2.renderUserInput(input));
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "clearfix input-radio-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "help-block inline-help text-danger text-left col-xs-12"
      }, this.state.errorText)));
    }
  }]);
  return RadioGroup;
}(_react.default.Component);
RadioGroup.propTypes = {
  inputData: _propTypes.default.array,
  groupName: _propTypes.default.text,
  isRequired: _propTypes.default.bool
};